import { render, staticRenderFns } from "./bi-data-source.vue?vue&type=template&id=1cde22fe"
import script from "./bi-data-source.vue?vue&type=script&lang=js"
export * from "./bi-data-source.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports